import { ROUTES } from '@/constants';

import { LUCKY_TICKET_AD } from '../_constants';

const QUICK_MENU_TILE_COUNT = 5;

export const isLuckyTicketAdItem = (item: {
  url?: string;
  placementKey?: string;
}) => !item.url && item.placementKey === LUCKY_TICKET_AD;

//* 「행운권 열기」는 모으기 탭 목록에만 남긴다 — 퀵메뉴 줄은 서버 항목 + 방문 행운권 몰로 5칸 고정(기획 3-6).
//* 광고보기는 서버 순서와 무관하게 몰 칸 뒤 맨 끝으로 보내고, 앱이 아니면 칸째 숨겨 몰 칸이 채운다.
export const resolveQuickMenuTiles = <
  T extends { url?: string; placementKey?: string },
>(
  items: T[],
  isWelloApp: boolean,
) => {
  const adItem = isWelloApp ? items.find(isLuckyTicketAdItem) : undefined;
  const menuItems = items
    .filter(
      (item) =>
        item.url !== ROUTES.BENEFIT_SCRATCH.pathname &&
        !isLuckyTicketAdItem(item),
    )
    .slice(0, QUICK_MENU_TILE_COUNT - (adItem ? 1 : 0));

  return {
    menuItems,
    adItem,
    merchantTileCount:
      QUICK_MENU_TILE_COUNT - menuItems.length - (adItem ? 1 : 0),
  };
};
